import { useNavigate, useParams } from "react-router-dom";
import { Asterisk, Award, Calendar, Envelope, List, People, Person, PersonBadge, Phone, PinMap, TextParagraph } from "react-bootstrap-icons";
import { useContext, useState } from "react";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import { config } from "../../constants/config";
import UserContext from "../../contexts/UserContext";



export default function ViewOparation() {
    // states
    let codeoperation = useParams();
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [codeutilisateur, setCodeutilisateur] = useState("");
    const [codelicence, setCodelicence] = useState("");
    const [codeconnexion, setCodeconnexion] = useState("");
    const [codecompte, setCodecompte] = useState("");
    const [codeespatrav, setCodeespatrav] = useState("");
    const [codeprofil, setCodeprofil] = useState("");

    const [action, setAction] = useState("");
    const [objetaction, setObjetaction] = useState("");
    const [desc, setDesc] = useState("");
    const [resultat, setResultat] = useState("");
    const [datecrea, setDatecrea] = useState("");

    const [libprofil, setLibprofil] = useState("");
    const [identprofil, setIdentprofil] = useState("");
    const [descprofil, setDescprofil] = useState("");
    const [etatprofil, setEtatprofil] = useState("");

    const [nomutilisateur, setNomutilisateur] = useState("");
    const [prenomutilisateur, setPrenomutilisateur] = useState("");
    const [nationnalite, setNationnalite] = useState("");
    const [numerotel, setNumerotel] = useState("");
    const [email, setEmail] = useState("");


    const [etatlicene, setEtatlicence] = useState("");
    const [liblicene, setLibLicence] = useState("");
    const [dureelicene, setDureeLicence] = useState("");
    const [desclicene, setDescLicence] = useState("");
    const [datedeblicene, setDtedeblicence] = useState("");
    const [datefinlicene, setDtefinlicence] = useState("");

    const [nomcompte, setNomcompte] = useState('');
    const [loginompte, setLoginompte] = useState('');
    const [etatcompte, setEtatcompte] = useState('');

    const [libesptrav, setLibesptrav] = useState("");
    const [identesptrav, setIdentesptrav] = useState("");
    const [descesptrav, setDescesptrav] = useState("");
    const [etatesptrav, setEtatesptrav] = useState("");

    const [photoprev, setPhoto] = useState('');


    const getOperations = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/snitchs/${codeoperation.code}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setLibprofil(body?.libprofil !== null ? body?.libprofil : "");
                        setIdentprofil(body?.identprofil !== null ? body?.identprofil : "");
                        setDescprofil(body?.descrprofil !== null ? body?.descrprofil : "");
                        setEtatprofil(body?.etatprofil);
                        setCodeutilisateur(body?.codeutilisateur !== null ? body?.codeutilisateur : "");
                        setCodelicence(body?.codelicence !== null ? body?.codelicence : "");
                        setCodeconnexion(body?.codeconnexion !== null ? body?.codeconnexion : "");
                        setCodecompte(body?.codecompte !== null ? body?.codecompte : "");
                        setCodeespatrav(body?.codeesptrav !== null ? body?.codeesptrav : "");
                        setCodeprofil(body?.codeprofil !== null ? body?.codeprofil : "");
                        setAction(body?.action !== null ? body?.action : "");
                        setDesc(body?.description !== null ? body?.description : "");
                        setObjetaction(body?.objetaction !== null ? body?.objetaction.replace("{", "").replace("}", "") : "");
                        setResultat(body?.resultats !== null ? body?.resultats : "");
                        setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 19).replace("T", " à ") : "");

                        setNomutilisateur(body?.nom !== null ? body?.nom : "");
                        setPrenomutilisateur(body?.prenom !== null ? body?.prenom : "");
                        setNationnalite(body?.nationalite !== null ? body?.nationalite : "");
                        setNumerotel(body?.numerotel !== null ? body?.numerotel : "");
                        setEmail(body?.email !== null ? body?.email : "");

                        setLibLicence(body?.lib !== null ? body?.lib : "");
                        setDureeLicence(body?.duree !== null ? body?.duree : "");
                        setDescLicence(body?.descrlic !== null ? body?.descrlic : "");
                        setDtedeblicence(body?.datedeblic !== null ? body?.datedeblic.slice(0, 19).replace("T", " à ") : "");
                        setDtefinlicence(body?.datefinlic !== null ? body?.datefinlic.slice(0, 19).replace("T", " à ") : "");
                        setEtatlicence(body?.etatlic);

                        setNomcompte(body?.nomcompte !== null ? body?.nomcompte : "");
                        setLoginompte(body?.logincompte !== null ? body?.logincompte : "");
                        setEtatcompte(body?.etatcompte);

                        setLibesptrav(body?.libesptrav !== null ? body?.libesptrav : "");
                        setIdentesptrav(body?.identesptrav !== null ? body?.identesptrav : "");
                        setDescesptrav(body?.descresptrav !== null ? body?.descresptrav : "");
                        setEtatesptrav(body?.etatesptrav);

                        setPhoto((body?.photo !== null) ? body?.photo : "/assets/imgs/blank.png");

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    // comportements
    useEffect(() => {
        getOperations();
    }, [])

    const handleSubmitEdit = async (e) => {

        e.preventDefault();
    }



    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-4 font-weight-bold text_primary">Activities</h1>
            <div className="row">
                <div className="col-md-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                <i className="fa fa-reply"></i> <span>Retour</span>
                            </button>
                            {/* {!editedstate && <button onClick={() => setEditedstate(true)}
                                                title="Modifier l'activité" 
                                                className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                                <i className="fa fa-edit mr-1"></i> <span>Modifier</span>
                                            </button>}
                                            {!editedstate && <button onClick={handleDelete}
                                                title="Supprimer l'activité" 
                                                className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                                <i className="fa fa-trash mr-1"></i> <span>Supprimer</span>  {deleting && <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                />}
                                            </button>} */}
                            <h6 className="m-0 ">Activity informations</h6>
                        </div>
                        <div className="card-body">
                            <form style={{ width: "100%" }} onSubmit={handleSubmitEdit}>
                                <div className="row">
                                    {/* <div className="col-md-4 mb-3">
                                                        <div className="row">
                                                            <div className="col-md-12 mb-2">
                                                                <label htmlFor="logo" className="form-label">Logo du client</label>
                                                                <input className="form-control" type="file" id="logo" onChange={handleLogoChange} />
                                                            </div>
                                                            <div className="col-md-12 mb-1">
                                                                <img alt="" src={photoprev} className="rounded" style={{width: "100%"}} />
                                                            </div>
                                                        </div>
                                                    </div> */}
                                    <div className="col-md-12 mb-3">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="objet" className="mb-1">Object of activity</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="objet">
                                                        <Award />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="No object"
                                                        value={objetaction}
                                                        onChange={(e) => setObjetaction(e.target.value)}
                                                        disabled={editedstate ? false : true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="action" className="mb-1">Action of activity</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="action">
                                                        <Award />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="No action"
                                                        value={action}
                                                        onChange={(e) => setAction(e.target.value)}
                                                        disabled={editedstate ? false : true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="desc" className="mb-1">Description of activity</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="desc">
                                                        <TextParagraph />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="No description"
                                                        value={desc}
                                                        onChange={(e) => setDesc(e.target.value)}
                                                        disabled={editedstate ? false : true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="resultat" className="mb-1">Result of activity</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="resultat">
                                                        <List />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="No result"
                                                        value={resultat}
                                                        onChange={(e) => setResultat(e.target.value)}
                                                        disabled={editedstate ? false : true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-5">
                                                <label htmlFor="dateop" className="mb-1">Date of activity</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="dateop">
                                                        <Calendar />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        value={datecrea}
                                                        onChange={(e) => setDatecrea(e.target.value)}
                                                        disabled
                                                    />
                                                </div>
                                            </div>


                                            <div className="col-md-12 mb-3">
                                                <h4 className="mb-2">User's informations</h4>
                                                <div className="row">
                                                    <div className="col-md-4 mb-3">
                                                        <div className="row">
                                                            {/* {editedstate && <div className="col-md-12 mb-2">
                                                                                <label htmlFor="photo" className="form-label">Photo de l'utilisateur</label>
                                                                                <input className="form-control" type="file" id="photo" onChange={handleLogoChange} />
                                                                            </div>} */}
                                                            <div className="col-md-12 mb-1">
                                                                <img alt="" src={photoprev} className="rounded" style={{ width: "100%" }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-8 mb-3">
                                                        <div className="row">
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="noms" className="mb-1">Firstname</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="noms">
                                                                        <Person />
                                                                    </span>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        placeholder="No Firstname"
                                                                        value={nomutilisateur}
                                                                        onChange={(e) => setNomutilisateur(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="prenom" className="mb-1">Lastname</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="prenom">
                                                                        <Person />
                                                                    </span>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        placeholder="No lastname"
                                                                        value={prenomutilisateur}
                                                                        onChange={(e) => setPrenomutilisateur(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="adresse" className="mb-1">Nationality</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="adresse">
                                                                        <PinMap />
                                                                    </span>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        placeholder="No nationality"
                                                                        value={nationnalite}
                                                                        onChange={(e) => setNationnalite(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="email" className="mb-1">Email address</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="email">
                                                                        <Envelope />
                                                                    </span>
                                                                    <input type="email"
                                                                        className="form-control"
                                                                        placeholder="No Email address"
                                                                        value={email}
                                                                        onChange={(e) => setEmail(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="tel1" className="mb-1">Phone number</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="tel1">
                                                                        <Phone />
                                                                    </span>
                                                                    <input type="tel"
                                                                        className="form-control"
                                                                        placeholder="No phone number"
                                                                        value={numerotel}
                                                                        onChange={(e) => setNumerotel(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12 mb-2 mt-3">
                                                                <h4>Account user's informations</h4>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="login" className="mb-1">Username</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="login">
                                                                        <Person />
                                                                    </span>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        value={loginompte}
                                                                        onChange={(e) => setLoginompte(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="profil" className="mb-1">Account profil</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="profil">
                                                                        <PersonBadge />
                                                                    </span>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        value={libprofil}
                                                                        onChange={(e) => setLibprofil(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="esptrav" className="mb-1">Account Workspace</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="esptrav">
                                                                        <People />
                                                                    </span>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        value={libesptrav}
                                                                        onChange={(e) => setLibesptrav(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="etatcpte" className="mb-1">Account state</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className={`input-group-text ${etatcompte === 1 ? "bg-success" :
                                                                        etatcompte === 2 ? "bg-danger" :
                                                                            "bg-light"
                                                                        }`
                                                                    }
                                                                        id="etatcpte"
                                                                    >
                                                                        <Asterisk />
                                                                    </span>
                                                                    <input
                                                                        disabled
                                                                        type="text"
                                                                        className={`form-control ${etatcompte === 1 ? "text-white bg-success" :
                                                                            etatcompte === 2 ? "text-white bg-danger" :
                                                                                "bg-light"
                                                                            } 
                                                                                        `}
                                                                        id="etat"
                                                                        value={
                                                                            etatcompte === 1 ? "Active account" :
                                                                                etatcompte === 2 ? "Desabled account" :
                                                                                    ""
                                                                        }
                                                                        placeholder="Etat du compte"
                                                                        onChange={(e) => setEtatcompte(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {/* <div className="col-md-12 mb-2 mt-3">
                                                                                <h4>Informations sur la licence utilisé</h4>
                                                                            </div>
                                                                            <div className="col-md-6 mb-3">
                                                                                <label htmlFor="libellelic" className="mb-1">Libelle</label>
                                                                                <div className="input-group flex-nowrap">
                                                                                    <span className="input-group-text" id="libellelic">
                                                                                        <TextParagraph />
                                                                                    </span>
                                                                                    <input type="text" 
                                                                                        className="form-control"
                                                                                        value={liblicene}
                                                                                        onChange={(e) => setLibLicence(e.target.value)}
                                                                                        disabled={editedstate ? false : true}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 mb-3">
                                                                                <label htmlFor="etatlic" className="mb-1">Etat de la licence</label>
                                                                                <div className="input-group flex-nowrap">
                                                                                    <span className={`input-group-text ${
                                                                                            etatlicene === 1 ? "bg-success" :
                                                                                            etatlicene === 2 ? "bg-warning" :
                                                                                            etatlicene === 3 ? "bg-danger" :
                                                                                            "bg-light"
                                                                                        }`
                                                                                    } 
                                                                                        id="etatlic"
                                                                                    >
                                                                                        <Asterisk />
                                                                                    </span>
                                                                                    <input
                                                                                        disabled
                                                                                        type="text" 
                                                                                        className={`form-control ${
                                                                                                etatlicene === 1 ? "text-white bg-success" :
                                                                                                etatlicene === 2 ? "text-white bg-warning" :
                                                                                                etatlicene === 3 ? "text-white bg-danger" :
                                                                                                "bg-light"
                                                                                            } 
                                                                                        `} 
                                                                                        id="etatlic"
                                                                                        value={
                                                                                            etatlicene === 1 ? "Licence en cours d'utilisation" :
                                                                                            etatlicene === 2 ? "Licence suspendue" :
                                                                                            etatlicene === 3 ? "Licence expirée" :
                                                                                            ""
                                                                                        }
                                                                                        placeholder="Etat de la licence"
                                                                                        onChange={(e) => setEtatlicence(e.target.value)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 mb-3">
                                                                                <label htmlFor="datdeb" className="mb-1">Date de début</label>
                                                                                <div className="input-group flex-nowrap">
                                                                                    <span className="input-group-text" id="datdeb">
                                                                                        <Calendar />
                                                                                    </span>
                                                                                    <input type="text" 
                                                                                        className="form-control"
                                                                                        value={datedeblicene}
                                                                                        onChange={(e) => setDtedeblicence(e.target.value)}
                                                                                        disabled
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 mb-3">
                                                                                <label htmlFor="datefin" className="mb-1">Date de fin</label>
                                                                                <div className="input-group flex-nowrap">
                                                                                    <span className="input-group-text" id="datefin">
                                                                                        <Calendar />
                                                                                    </span>
                                                                                    <input type="text" 
                                                                                        className="form-control"
                                                                                        value={datefinlicene}
                                                                                        onChange={(e) => setDtefinlicence(e.target.value)}
                                                                                        disabled
                                                                                    />
                                                                                </div>
                                                                            </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                            {/* <div className="col-md-12 mb-3">
                                                                <label htmlFor="desc" className="mb-1">Description</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="desc">
                                                                        <TextParagraph />
                                                                    </span>
                                                                    <textarea 
                                                                        className="form-control" 
                                                                        placeholder="Entrez la description du client"
                                                                        value={desc}
                                                                        onChange={(e) => setDesc(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div> */}
                                        </div>
                                    </div>
                                    {editedstate && <div className="col-md-12 mt-2">
                                        <button type="submit"
                                            title="Modifier la licence"
                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                        // disabled={name && desc && client["value"]  && type["value"] ? false : true}
                                        >
                                            <i className="fa fa-check mr-2"></i>
                                            <span>Update</span> {fetching && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>
                                        <button onClick={() => setEditedstate(false)}
                                            title="Annuler l'opération"
                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                            <i className="fa fa-reply mr-1"></i> <span>Annuler</span>
                                        </button>
                                    </div>}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}